var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-wrapper',[(_vm.authReady || !_vm.$route.meta.auth)?_c('app-layout',[_c('router-view')],1):_vm._e(),_c('template',{slot:"app-loading"},[_vm._v("APP LOADING...")]),_c('auth-header',{attrs:{"slot":"auth-header"},slot:"auth-header"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }